const urlRoot = '/customers';
const urlV2Root = '/v2/customers';

export const URL = {
    create: urlRoot,
    customer: `${urlRoot}/{id}`,
    auth: `${urlRoot}/auth`,
    refresh: `${urlRoot}/auth/refresh`,
    reset: `${urlRoot}/reset-password`,
    activateSmartcard: `${urlRoot}/{id}/smartcard/activate`,
    findSeasonTickets: `${urlRoot}/{id}/ticket-search`,
    transferSeasonTicket: `${urlRoot}/{id}/product-swap`,
    preferences: `${urlRoot}/{id}/preferences`,
    postCodeLookUp: `${urlRoot}/address/postcode-lookup`,
    setPasswordAndPreferences: `${urlRoot}/set-password-and-preferences`,
    validateBacs: `${urlRoot}/validation/bacs-lookup`,
    checkEmail: `${urlRoot}/email`,
    deleteCustomer: `${urlRoot}/{id}/deactivate`,
    cancelDeletionRequest: `${urlRoot}/{id}/deactivate/{requestId}/cancel`,
    consentsTemplate: `${urlV2Root}/dataguard/consents/template`,
    consents: `${urlV2Root}/{id}/dataguard/consents`,
    dataguardManageToken: `${urlV2Root}/{id}/dataguard/access-token`,
    preferencesV2: `${urlV2Root}/{id}/preferences`,
};
